var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-builder',{model:{value:(_vm.ptw),callback:function ($$v) {_vm.ptw=$$v},expression:"ptw"}})}
var staticRenderFns = []

export { render, staticRenderFns }